export default "__VITE_ASSET__87e966b8__"